import { Option } from 'ui-builder';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezonePlugin from 'dayjs/plugin/timezone';
import { getTimeZones } from '@vvo/tzdb';

dayjs.extend(utc);
dayjs.extend(timezonePlugin);

export function useTimezonesHelper(deviceTimezone: string) {

  const getTimezones = (): Option<string>[] => {
    const tzdbZones = getTimeZones();

    const getTimezoneOffset = (timeZone: string): number => {
      return dayjs().tz(timeZone).utcOffset();
    };

    const getTimezoneAbbr = (timeZone: string): string => {
      const offsetMinutes = dayjs().tz(timeZone).utcOffset();
      const offsetHours = Math.floor(Math.abs(offsetMinutes) / 60);
      const offsetSign = offsetMinutes >= 0 ? '+' : '-';
      const paddedHours = String(offsetHours).padStart(2, '0');
      const offsetRemainder = Math.abs(offsetMinutes) % 60;
      const paddedMinutes = String(offsetRemainder).padStart(2, '0');

      return `GMT${offsetSign}${paddedHours}:${paddedMinutes}`;
    };

    const timeZoneOptions: Option<string>[] = tzdbZones.map((tz) => {
      const offset = getTimezoneOffset(tz.name);
      const abbr = getTimezoneAbbr(tz.name);

      return {
        value: tz.name,
        label: `${tz.name.replace('_', ' ')} (${abbr})`,
        offset,
      };
    });

    return timeZoneOptions.sort((a, b) => {
      if (a.value === deviceTimezone) return -1;
      if (b.value === deviceTimezone) return 1;

      if (a.offset === b.offset && typeof a.label === 'string' && typeof b.label === 'string') {
        return a.label.localeCompare(b.label);
      } else {
        return a.offset - b.offset;
      }
    });
  };

  const getLabel = (timezone: string): string => {
    const getTimezoneAbbr = (timeZone: string): string => {
      const offsetMinutes = dayjs().tz(timeZone).utcOffset();
      const offsetHours = Math.floor(Math.abs(offsetMinutes) / 60);
      const offsetSign = offsetMinutes >= 0 ? '+' : '-';
      const paddedHours = String(offsetHours).padStart(2, '0');
      const offsetRemainder = Math.abs(offsetMinutes) % 60;
      const paddedMinutes = String(offsetRemainder).padStart(2, '0');

      return `GMT${offsetSign}${paddedHours}:${paddedMinutes}`;
    };

    const abbr = getTimezoneAbbr(timezone);
    return `${timezone.replace('_', ' ')} (${abbr})`;
  };

  return {
    getTimezones,
    getLabel,
  };
}
